import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { $getRoot, $insertNodes } from 'lexical';
import { ImageNode } from '../nodes/ImageNode';
import { INSERT_IMAGE_COMMAND } from '../commands';

export function ImagePlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_IMAGE_COMMAND,
      (files: File[]) => {
        files.forEach(file => {
          editor.update(() => {
            const imageNode = new ImageNode(file, file.name);
            $insertNodes([imageNode]);
          });
        });
        return true;
      },
      1
    );
  }, [editor]);

  return null;
} 